<template>
  <BaseTableWrapper>
    <template #top-buttons>
      <router-link
        tag="button"
        :to="{ name: 'EXCMCarCreate' }"
        class="mb-1 btn btn-sm btn-primary float-right">{{$t('buttons.create')}}</router-link>
    </template>
    <template #fitlering></template>
    <template #body>
      <Loader v-if="isLoading"></Loader>
      <span v-else-if="!isLoading && items.length < 1">{{ $t('views.excmcar.list.noCars') }}</span>
      <table v-else class="table table-sm table-responsive-md table-striped table-hover">
        <thead>
        <tr>
          <th>{{$t('views.excmcar.list.name')}}</th>
          <th>{{$t('views.excmcar.list.model')}}</th>
          <th>{{$t('views.excmcar.list.registrationNumber')}}</th>
          <th style="width: 5%" colspan="1" />
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="item in items"
          :key="item['@id']">
          <td>
            {{ item['name'] }}
          </td>
          <td>
            {{ item['model'] }}
          </td>
          <td>
            {{ item['registrationNumber'] }}
          </td>
          <td>
            <div class="btn-group">
              <router-link
                tag="button"
                :to="{name: 'EXCMCarUpdate', params: { id: item['@id'] }}"
                class="float-right btn btn-link fa fa-edit fa-lg"
                v-b-tooltip.hover :title="$t('buttons.edit')" aria-hidden="true" />
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div v-if="view">
        <pagination
          :view="view"
          @getPage="getPage($event)"
        ></pagination>
      </div>
    </template>
  </BaseTableWrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'
import Pagination from '../../Layout/Pagination'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'

export default {
  components: {
    Loader,
    Pagination,
    BaseTableWrapper
  },

  computed: mapGetters({
    deletedItem: 'excmcar/del/deleted',
    error: 'excmcar/list/error',
    items: 'excmcar/list/items',
    isLoading: 'excmcar/list/isLoading',
    view: 'excmcar/list/view'
  }),

  beforeCreate () {
    checkPagePermission('configuration', 'EXCMCarList')
  },

  created () {
    this.getPage()
  },

  methods: mapActions({
    getPage: 'excmcar/list/default'
  })
}
</script>
